import { api } from "@/api";
import { UpdateSportNewParams, SportDto } from "@/types/ApiResponses/Sport";

export const updateSportNew = async (
  params: UpdateSportNewParams
): Promise<SportDto> => {
  const { id, ...body } = params;
  const res = await api.client.patch(`/sports-new/${id}`, body);
  return res.data;
};
